import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-trust-navy-dark text-white">
      <div className="w-full px-4 sm:px-6 lg:px-10 xl:px-16 py-10 md:py-14">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm font-bold text-white font-jp">
            {t('company.brand')}
          </p>
          <p className="text-sm text-white/70">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}